import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3dbb105c&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb105c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dbb105c')) {
      api.createRecord('3dbb105c', component.options)
    } else {
      api.reload('3dbb105c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3dbb105c&scoped=true", function () {
      api.rerender('3dbb105c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/cdkey/index.vue"
export default component.exports